<template>
	<div>
		<div class="uk-container">
			<div class="intro">
				<h2>Der Schnellstarter für Immobilien-Websites:</h2>
				<h1>Einfach anmelden, Objekte übertragen und los&nbsp;geht's!</h1>

				<div class="intro__keynote">
					<p>
						immonex ONE ist die <strong>Website-Komplettlösung</strong> für Immobilienmakler/innen, die unabhängig sind
						und bleiben wollen &ndash; flexibel, kostengünstig und sicher.
					</p>

					<a href="#reasons" class="uk-flex-inline uk-flex-middle intro__toggle" tabindex="-1" uk-toggle="target: #reasons, #hinnak; animation: uk-animation-fade"><span>Wie?</span> <span uk-icon="icon: chevron-down; ratio: 2"></span></a><br>
				</div>
			</div>

			<div id="reasons" hidden>
				<div uk-grid>
					<div class="uk-width-1-2@s uk-width-1-3@m">
						<h3 class="uk-margin-remove-bottom">Fokussiert</h3>
						<p class="uk-margin-remove-top">
							auf das Wesentliche: Funktionen und Inhalte, die
							<strong>wirklich</strong> wichtig sind. Die erfolgreiche
							Vermarktung	und Akquise von Immobilien im Internet beginnt
							genau hier!
						</p>
					</div>

					<div class="uk-width-1-2@s uk-width-1-3@m">
						<h3 class="uk-margin-remove-bottom">Schnell</h3>
						<p class="uk-margin-remove-top">
							einsatzbereit durch eine fix und fertig eingerichtete
							Grundinstallation, die in nur <strong>wenigen Minuten</strong>
							aktiviert und anschließend ganz einfach mit eigenen
							Inhalten befüllt werden kann.
						</p>
					</div>

					<div class="uk-width-1-2@s uk-width-1-3@m">
						<h3 class="uk-margin-remove-bottom">Offen</h3>
						<p class="uk-margin-remove-top">
							Immobilien-Angebote	können mit jeder gängigen Branchen-Softwarelösung
							via <strong>OpenImmo-Schnittstelle</strong>	übertragen werden. Diese
							werden automatisch auch unter <a href="https://immonex.de/" target="_blank" tabindex="-1">immonex.de</a>
							veröffentlicht (in Vorbereitung).
						</p>
					</div>

					<div class="uk-width-1-2@s uk-width-1-3@m">
						<h3 class="uk-margin-remove-bottom">Sicher</h3>
						<p class="uk-margin-remove-top">
							durch eine kontinuierliche Überwachung und Aktualisierung aller
							Systemkomponenten sowie die regelmäßige Prüfung der rechtlich
							relevanten Inhalte durch Profis.
						</p>
					</div>

					<div class="uk-width-1-2@s uk-width-1-3@m">
						<h3 class="uk-margin-remove-bottom">Ansprechend</h3>
						<p class="uk-margin-remove-top">
							mit einem eleganten, klaren Design, das von Haus aus auch
							für	Mobilgeräte, Suchmaschinen & Co. optimiert ist und
							kontinuierlich weiterentwickelt wird.
						</p>
					</div>

					<div class="uk-width-1-2@s uk-width-1-3@m">
						<h3 class="uk-margin-remove-bottom">Grundsolide</h3>
						<p class="uk-margin-remove-top">
							mit WordPress als Basis in Kombination mit den praxiserprobten
							immonex-Erweiterungen, die bereits in Hunderten von
							Immobilien-Websites erfolgreich eingesetzt werden.
						</p>
					</div>

					<div class="uk-width-1-2@s uk-width-1-3@m">
						<h3 class="uk-margin-remove-bottom">Fair</h3>
						<p class="uk-margin-remove-top">
							dank kostenloser Testphase, kurzen Laufzeiten,
							transparenten Kosten, flexibler Zahlung und dem Verzicht auf
							Lock-in-Effekte: Pausieren, Wechseln oder Kündigen ist
							jederzeit problemlos möglich.
						</p>
					</div>

					<div class="uk-width-1-2@s uk-width-1-3@m">
						<h3 class="uk-margin-remove-bottom">Individuell</h3>
						<p class="uk-margin-remove-top">
							in einem sinnvollen Rahmen: Logo- und Farbschema, Inhaberfoto,
							eigene Texte. Eine eigene Domain sowie optionale Zusatzmodule
							können flexibel zu- oder abgebucht werden.
						</p>
					</div>

					<div class="uk-width-1-2@s uk-width-1-3@m">
						<h3 class="uk-margin-remove-bottom">Zukunftssicher</h3>
						<p class="uk-margin-remove-top">
							als Teil des ständig wachsenden immonex-Ökosystems aus Software,
							Dienstleistungen, Entwicklern, Agenturen und Partnern aus der
							Immobilienbranche.
						</p>
					</div>
				</div>
			</div>

			<div id="hinnak">
				<div>Ohne</div>
				<div><img src="../assets/bullshitfrei.png" alt="Illustration: Bulle Hinnak" width="200" height="195"></div>
				<div>Bullshit!</div>
			</div>

		</div>

		<div id="signup-wrap" v-if="signupEnabled">
			<signup></signup>

			<div id="preview-wrap">
				<div class="preview-wrap__inner">
					<iframe
						id="preview"
						:src="previewUrl"
						scrolling="no"
						tabindex="-1"
						@load="iframeLoaded"
					/>
				</div>
			</div>
		</div>

		<div id="signup-disabled-wrap" class="uk-container uk-margin-large-top" v-if="!signupEnabled">
			Das Anlegen neuer immonex ONE Websites ist bald wieder möglich!<br>
			Bitte haben Sie noch etwas Geduld!
		</div>

		<div class="uk-container uk-margin-large" v-if="showFAQ">
			<h2 id="faq">Häufig gestellte Fragen</h2>

			<dl>
				<dt>Kann ich auch eine individuelle Domain für meine immonex-ONE-Website verwenden?</dt>
				<dd>Ja!</dd>
				<dt>Wirklich?</dt>
				<dd>Ja!</dd>
				<dt>Ganz sicher?</dt>
				<dd>Ja!</dd>
			</dl>
		</div>
	</div>
</template>

<script>
import iFrameResize from 'iframe-resizer/js/iframeResizer'

import Signup from './Signup'

export default {
	name: 'home',
	data () {
		return {
			signupEnabled: false,
			previewUrl: process.env.VUE_APP_PREVIEW_URL,
			showFAQ: false
		}
	},
	methods: {
		iframeLoaded () {
			var scrolled = false

			iFrameResize({
				log: false,
				onResize: () => {
					if (scrolled) return

					if (this.$route.hash) {
						this.$root.scrollTo(this.$route.hash)
					}
					scrolled = true
				}
			},
			'#preview')
		}
	},
	components: { Signup },
	mounted () {
		this.signupEnabled = process.env.VUE_APP_SIGNUP_ENABLED == 1 ? true : false
	}
}
</script>

<style lang="scss" scoped>
h1 {

}

#signup-wrap {
	position: relative;
}

#signup-disabled-wrap {
	font-size: 1.5em;
}

#preview-wrap {
	padding: 4em 0;
	background: repeating-linear-gradient(
		-45deg,
		#555,
		#555 1em,
		#444 1em,
		#444 2em
	);
}

.preview-wrap__inner {
	width: 100%;
	min-height: 800px;
	background: #fff;
}

#preview {
	width: 100%;
	height: auto;
	min-height: 100%;
	border: none;
}

#loading {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: #EEE;
	opacity: .8;
	display: none;
	align-items: center;
	justify-content: center;
}

#content {
	#hinnak {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 1em;
		font-size: 2em;

		div {
			padding: 0 .2em;
		}

		img {
			width: auto;
			max-height: 8em;
			margin-bottom: 1em;
		}
	}

	#reasons {
		margin-bottom: 3em;
	}

	.intro {
		text-align: center;

		h1 {
			margin-top: 0;
			margin-bottom: 1em;
		}

		h2 {
			margin-bottom: .5em;
			color: #666;
			font-size: 1.8em;
		}
	}

	.intro__keynote {
		display: inline-block;
		max-width: 44em;
		font-size: 1.5em;
	}

	.intro__toggle {
		font-size: 2em;
	}
}

/* Screen M */
@media screen and (min-width: 960px) {
	#preview-wrap {
		padding: 2em;
	}

	#content {
		.intro {
			h1,
			h2 {
				display: inline-block;
			}

			h1 {
				max-width: 17em;
				margin-bottom: 2em;
				font-size: 3em;
			}

			h2 {
				font-size: 2em;
			}

			.intro__keynote {
				font-size: 1.8em;
			}
		}

		#hinnak {
			font-size: 4em;

			img {
				max-height: 9em;
			}
		}
	}
}
</style>
